module.exports = __webpack_public_path__ + "img/50f2d65c61ca15e45ec4337fbbea256f.png";